import Vue from 'vue';
import colors from 'vuetify/lib/util/colors'
import Vuetify from "vuetify";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary: '#46b4c1', // Ihre ursprüngliche Primärfarbe
                secondary: '#31b64b', // Ihre neue sekundäre Farbe
                tertiary: '#000000',
                accent: '#f1f8f9', // Weitere Farben können nach Bedarf hinzugefügt werden
                success: '#3dd23d',
                grey: '#F7F7F7',
                error: colors.red.accent3,
            },
            dark: {
                primary: colors.blue.lighten3,
            },
        },
    },
});
